import { addDays } from "date-fns";

/**
 * 10th business day inclusive (Mon-Fri, holidays ignored) -- the dialog's standard;
 * the backend's +14 calendar days default is unrelated.
 *
 * The start counts as day 1 whatever weekday it is; from there one calendar day is
 * added at a time and only Mon-Fri are counted, stopping after nine more.
 */
export function computeSettlingInEndDate(start: Date): Date {
  let businessDaysAdded = 0;
  let endDate = start;
  while (businessDaysAdded < 9) {
    endDate = addDays(endDate, 1);
    const day = endDate.getDay();
    if (day !== 0 && day !== 6) {
      businessDaysAdded++;
    }
  }
  return endDate;
}
